<!-- TEMPLATE -->
<template>
  <div class="sidebar">
    <!--
        Tip 1: You can change the color of the sidebar using: data-color="blue | green | orange | red"
    -->
    <div class="sidebar-wrapper">
      <div class="logo">
        <a href="javascript:void(0)" class="simple-text logo-mini">
          <i class="tim-icons icon-align-center"></i>
        </a>
        <a href="javascript:void(0)" class="simple-text logo-normal"> Menu </a>
      </div>
      <ul class="nav">
        <li v-bind:class="{ active: checkActiveLink('/dashboard') }" style="margin-left: -25px">
          <a href="/dashboard">
            <i class="tim-icons icon-chart-pie-36"></i>
            <p>Web Protect</p>
          </a>
        </li>
        <li v-bind:class="{ active: checkActiveLink('/dashboard-email') }" style="margin-left: -25px">
          <a href="/dashboard-email">
            <i class="tim-icons icon-email-85"></i>
            <p>Email Protect</p>
          </a>
        </li>
        <li v-bind:class="{ active: checkActiveLink('/notifications') }" style="margin-left: -25px">
          <a href="/notifications">
            <i class="tim-icons icon-bell-55"></i>
            <p>Notifications</p>
          </a>
        </li>

        <li v-bind:class="{ active: checkActiveLink('/marketplace') } " style="margin-left: -25px" disabled>
          <a href="/marketplace" data-toggle="collapse" class="collapsed" aria-expanded="false">
            <i class="tim-icons icon-components"></i>
            <p>Marketplace</p>
          </a>
        </li>

        <li v-bind:class="{ active: checkActiveLink('/workflow') } " style="margin-left: -25px">
          <a href="/workflow" data-toggle="collapse" class="collapsed" aria-expanded="false">
            <i class="tim-icons icon-molecule-40"></i>
            <p>XDR</p>
          </a>
        </li>

        <li v-bind:class="{ active: checkActiveLink('/billing') }" style="margin-left: -25px">
          <a href="/billing">
            <i class="tim-icons icon-credit-card"></i>
            <p>Billing</p>
          </a>
        </li>

        <li v-bind:class="{ active: checkActiveLink('/settings') }" style="margin-left: -25px">
          <a href="/settings">
            <i class="tim-icons icon-settings-gear-63"></i>
            <p>Settings</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script>
export default {
  name: "Home",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
    };
  },
  mounted: function () {},
  methods: {
    checkActiveLink: function (v) {
      return this.$route.fullPath == v ? true : false;
    },
  },
};
</script>

<!-- Style -->
<style>
</style>